import { Component, Inject, OnDestroy } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface ResizeProfileModalOptions {
    image: File;
    maintainAspectRatio?: boolean;
}

@Component({
    selector: 'app-resize-profile-picture-modal',
    templateUrl: './resize-profile-picture-modal.component.html',
    styleUrls: ['./resize-profile-picture-modal.component.scss'],
})
export class ResizeProfilePictureModalComponent implements OnDestroy {
    private destroy$ = new Subject();

    public imageFile: File = undefined;

    public croppedImage: any = '';

    public options: any;

    public loaded = false;

    constructor(
        public dialogRef: MatDialogRef<ResizeProfilePictureModalComponent>,
        @Inject(MAT_DIALOG_DATA) options: ResizeProfileModalOptions,
    ) {
        this.options = {
            maintainAspectRatio: true,
            ...options,
        };

        this.imageFile = this.options.image;
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public imageCropped(event: ImageCroppedEvent): void {
        fetch(event.base64)
            .then((res) => res.blob())
            .then((blob) => {
                this.croppedImage = new File([blob], this.imageFile.name, { type: this.imageFile.type });
            });
    }

    get imageType(): string {
        return this.imageFile.type.split('/')[1];
    }

    public imageLoaded(): void {
        this.loaded = true;
    }

    public cropperReady(): void {
        // cropper ready
    }

    public loadImageFailed(): void {
        // show message
    }

    public closeModal(): void {
        this.dialogRef.close();
    }

    public complete(): void {
        this.dialogRef.close(this.croppedImage);
    }

    public retake(): void {
        this.dialogRef.close({ retake: true });
    }
}
